// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 477 ? "video-markers-guide" : chunkId) + "." + {"133":"20d33943","149":"743e29fa","255":"120c10b6","260":"14afd80f","266":"eae6a479","299":"9377a904","333":"280c9b54","477":"dfcd2001","481":"fa6a1777","596":"aa332557","817":"0db9811e"}[chunkId] + ".chunk.js";
};